import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ConfigSettings.css';
import ConfigSettingsForm from '../../../components/SiteAdmin/ConfigSettingsForm/ConfigSettingsForm';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getSiteSettings from './getSiteSettings.graphql'
import Loader from '../../../components/Common/Loader/Loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages'

export class ConfigSettings extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { getSiteSettings: { loading, getSiteSettings, refetch } } = this.props;
    let settingsCollection = {}

    if (!loading) {
      getSiteSettings.map((item) => {
        settingsCollection[item.name] = item.value
      })
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>
              {formatMessage(messages.configSettings)}
            </div>
            <div className={s.paddingRoutesSection}>
              <ConfigSettingsForm refetch={refetch} getSiteSettings={getSiteSettings} initialValues={settingsCollection} />
            </div>
          </div>
        </div>
      )
    }
    else {
      return <Loader type={"page"} show={loading} />
    }

  }
}


export default compose(injectIntl,
  withStyles(s),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: (props) => ({
      variables: {
        type: 'configSettings'
      },
      ssr: true,
    }),
  })
)(ConfigSettings)
